// extracted by mini-css-extract-plugin
module.exports = {"select-item":"AppConfigForm_select-item__jW91E"};